import { render, staticRenderFns } from "./index.vue?vue&type=template&id=370f732a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=370f732a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f732a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/var/jenkins_home/workspace/prod-web-xfans/components/banner.vue').default,Course: require('/var/jenkins_home/workspace/prod-web-xfans/components/course.vue').default})
